import axios from "axios";
import { API_BASE_URL, API_PASSWORD } from "./apiConfig"; // 👈 استدعاء

// إعداد Axios
const api = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    "Content-Type": "application/json",
  },
});

// New: جلب أحجام قواعد البيانات للتينانتس
export const getDatabaseSizes = () => {
  const token = localStorage.getItem("authToken");
  const url = `get/database/sizes?api_password=${API_PASSWORD}`;
  return api.get(url, {
    headers: token ? { Authorization: `Bearer ${token}` } : {},
  });
};

// New: جلب أحجام التخزين لجميع التينانتات
export const getAllTenantsStorageSize = () => {
  const token = localStorage.getItem("authToken");
  const url = `all/tenant/storage/size?api_password=${API_PASSWORD}`;
  return api.get(url, {
    headers: token ? { Authorization: `Bearer ${token}` } : {},
  });
};

// New: جلب حجم المجلد لتينانت معين
// export const getTenantFolderSize = (tenantId) => {
//   const token = localStorage.getItem("authToken");
//   const url = `tenant/storage/size/${tenantId}?api_password=${API_PASSWORD}`;
//   return api.get(url, {
//     headers: token ? { Authorization: `Bearer ${token}` } : {},
//   });
// };

export const getTenantFolderSize = async (tenantId) => {
  const token = localStorage.getItem("authToken");
  const url = `tenant/storage/size/${tenantId}?api_password=${API_PASSWORD}`;

  try {
    const response = await api.get(url, {
      headers: token ? { Authorization: `Bearer ${token}` } : {},
    });
    return response.data; // 👈 رجّع البيانات فقط
  } catch (error) {
    if (error.response) {
      console.error("❌ API Error:", error.response.data);
      throw error.response.data; // رجّع الرسالة الجاية من السيرفر
    } else {
      console.error("❌ Network Error:", error.message);
      throw error;
    }
  }
};

export const getAllBackups = async () => {
  const token = localStorage.getItem("authToken");
  const url = `get/all/backups?api_password=${API_PASSWORD}`;

  try {
    const response = await api.get(url, {
      headers: token ? { Authorization: `Bearer ${token}` } : {},
    });
    return response.data; // Return the backups data
  } catch (error) {
    if (error.response) {
      console.error("❌ API Error:", error.response.data);
      throw error.response.data; // Return server error message
    } else {
      console.error("❌ Network Error:", error.message);
      throw error;
    }
  }
};

// Updated: تنزيل النسخة الاحتياطية باستخدام اسم الملف الكامل
export const downloadBackup = async (backupFileName) => {
  const token = localStorage.getItem("authToken");
  // استخدام المسار الصحيح: backups/{filename}
  const url = `download/backup/${encodeURIComponent(backupFileName)}?api_password=${API_PASSWORD}`;

  try {
    const response = await api.get(url, {
      headers: token ? { Authorization: `Bearer ${token}` } : {},
      responseType: "blob", // ضروري لتنزيل الملفات
    });

    // إنشاء رابط تنزيل تلقائي
    const downloadUrl = window.URL.createObjectURL(new Blob([response.data]));
    const link = document.createElement("a");
    link.href = downloadUrl;
    link.setAttribute("download", backupFileName);
    document.body.appendChild(link);
    link.click();
    link.remove();
    window.URL.revokeObjectURL(downloadUrl);

    return { success: true, message: "تم تنزيل النسخة الاحتياطية بنجاح" };
  } catch (error) {
    console.error("❌ Download Error:", error);
    if (error.response) {
      throw new Error(error.response.data?.message || "فشل في تحميل الملف");
    } else {
      throw new Error(error.message || "حدث خطأ في الاتصال");
    }
  }
};


